<template>
  <span>
    <storyblok-component v-if="story" :blok="story.content" />
  </span>
</template>

<script setup lang="ts">
import { storyKey } from "~/injection-symbols"

const story = (await useSbStory("datenschutz")) as Ref<StoryblokPageStory>

provide(storyKey, story.value)
</script>
